// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* 设置全局 */\n.el-upload-list--picture-card .el-upload-list__item-thumbnail {\r\n    -o-object-fit: contain;\r\n       object-fit: contain;\n}\r\n", ""]);
// Exports
module.exports = exports;
